import 'animate.css';

export const AllTags = ({ tag }) => {
    return (
        <div className='animate__animated animate__pulse'>
            <button className="btn btn-outline btn-primary rounded-full no-animation">{tag}</button>
        </div>
    )
}